// extracted by mini-css-extract-plugin
export default {"container":"root_container__qpKyS","content":"root_content__mxVRu","section":"root_section__wDIPy"};